import React, { useEffect, useState } from "react";
import "../auth.scss";
import { logodarkimg, logoimg } from "../../../assets/images";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import OTPInput from "react-otp-input";
import useSnackbar from "../../../hooks/useSnackbar";
import { AuthService } from "../../../services";
import { useMutation } from "@tanstack/react-query";
import ButtonLoader from "../../../component/buttonLoader";

const Otp = () => {
  const [seconds, setSeconds] = useState(60);
  const location = useLocation();
  const email = location.state?.email || undefined;
  const mobile = location.state?.mobile || undefined;
  const countryCode = location.state?.countryCode || undefined;
  const screen = location.state?.screen || undefined;
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const { snackbar } = useSnackbar();
  const { sendOtp, verifyOtp } = AuthService();

  useEffect(() => {
    if (seconds < 60) {
      return;
    }

    const intervalId = setInterval(() => {
      setSeconds((prevTime) => {
        if (prevTime === 0) {
          clearInterval(intervalId);
          return 0;
        }

        return prevTime - 1;
      });
    }, 1000);
  }, [seconds]);

  const sendOtpMutation = useMutation({
    mutationFn: () => {
      return sendOtp({
        ...(email && { email }),
        ...(mobile && { mobile }),
        ...(countryCode && { countryCode }),
        type: "otp",
      });
    },
    onSuccess: (data) => {
      setSeconds(60);
      snackbar(data?.message || "", "info");
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  const verifyOtpMutation = useMutation({
    mutationFn: () => {
      if (otp.length !== 6) {
        snackbar("Please enter valid otp code" || "");
        return null;
      }

      return verifyOtp({
        ...(email && { email }),
        ...(mobile && { mobile }),
        ...(countryCode && { countryCode }),
        otp,
      });
    },
    onSuccess: (data) => {
      if (data) {
        if (screen === "forgot") {
          navigate("/reset-password", {
            state: {
              ...(email && { email }),
              ...(mobile && { mobile }),
              ...(countryCode && { countryCode }),
            },
          });
        } else {
          navigate("/create-profile", {
            state: {
              isEmailVerified: email ? true : false,
              isMobileVerified: mobile ? true : false,
              ...(email && { email }),
              ...(mobile && { mobile }),
              ...(countryCode && { countryCode }),
            },
          });
        }
        snackbar(data?.message || "", "info");
      }
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  return (
    <div className="wrapper_auth wrapper_Otp">
      <div className="wrap_left">
        <Link to={"/"}>
          <img src={logoimg} alt="logo" />
        </Link>
        <h1>
          Balance Your Body, <span></span> Empower Your Mind
        </h1>
      </div>
      <div className="wrap_right">
        <img className="logo" src={logodarkimg} alt="logo" />
        <h2>
          Enter the OTP code <span></span> sent to you
        </h2>
        <p className="mail_code">
          Code sent to{" "}
          <span style={{ color: "#2f65f5" }}>
            {" "}
            {email || `${countryCode} ${mobile}`}{" "}
          </span>{" "}
          unless you already have an account
        </p>
        <div className="wrapper_cstm_tabers">
          <div className="signup_wrap">
            <div className="otp_form">
              <div className="form_field">
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                />
              </div>
              {seconds < 1 ? (
                <span
                  className="resend_otp"
                  onClick={() => sendOtpMutation.mutate()}
                >
                  Resend OTP
                </span>
              ) : (
                <p>
                  Resend OTP in <b>00:{seconds}</b> Seconds
                </p>
              )}
              <div className="btn_wrap_login">
                <ButtonLoader
                  text={
                    <>
                      Verify <FaArrowRightLong />
                    </>
                  }
                  className="login"
                  isLoading={verifyOtpMutation.isPending}
                  onClick={() => verifyOtpMutation.mutate()}
                />
              </div>
            </div>
            <div className="account_signup">
              <p>
                By signing up, you agree to and{" "}
                <Link to="/terms"> Terms & Conditions </Link>
                <Link to="/policy">Privacy Policy.</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Otp;
